module.exports = __webpack_public_path__ + "static/final.9bf3efaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/fetching/final.png
// module id = 198
// module chunks = 28472069284183 167621382493667